/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from "react";

import {
  Input, SearchIcon, CloseIcon, ImportIcon,
  Button, Card, CardContent, CardHeader, Table,
  TableContent, TableHeader, FilterIcon, DensityMostIcon
} from "@forge/common";
import { useTranslation } from "react-i18next";

import { CustomizedTableProps } from "../../../models";
import { LOCALE_CONST } from "../../../utils/constants";

const CustomizedTable: React.FC<CustomizedTableProps> = ({
  title, tableHeaderData, tableContentData,
  showHideIconClick, filterIconClick, searchOnChange,
  searchValue, tableData, onSearchClear, onExportAction
}) => {
  const { t } = useTranslation();

  const onSearchChangeFn = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (searchOnChange) {
      searchOnChange(e.target.value);
    }
  };

  const renderSearchSuffix = () => {
    if (searchValue) {
      return (
        <div className="cursor-pointer" data-testid="search-close-test"
          onClick={onSearchClear}
        >
          <CloseIcon data-testid="search-close" />
        </div>
      );
    } else {
      return <></>;
    }
  };

  const renderTableContent = () => {
    if (tableData && tableData.length > 0) {
      return (
        <>
          <CardContent x="none" top="none" className="linked-device-table-card">
            <Table onCard>
              <TableHeader data={tableHeaderData} />
              <TableContent data={tableContentData} />
            </Table>
          </CardContent>
          <CardContent>
          </CardContent>
        </>
      );
    } else {
      return (
        <CardContent className="h-96 place-items-center grid">
          <p>{t(LOCALE_CONST.noResultsFound)}</p>
        </CardContent>
      );
    }
  };

  return (
    <>
      <Card className="customized-table-card">
        <CardHeader 
          title={title}
          className="card-header-title"
          slotRight={
            <div className="flex items-center gap-3 table-header-right-action">
              <Input type="text" data-testid="search-test"
                placeholder={t(LOCALE_CONST.search)} id="search"
                onChange={onSearchChangeFn} value={searchValue}
                prefix={<SearchIcon strokeWidth={2} />}
                suffix={renderSearchSuffix()} size="regular"
              />
              {filterIconClick && (
                <Button aria-label="Settings" data-testid="filter-icon-test"
                  icon={<FilterIcon strokeWidth={2.5} />}
                  variant="tertiary" onClick={filterIconClick}
                />
              )}
              {showHideIconClick && (
                <Button aria-label="show-hide"
                  icon={<DensityMostIcon strokeWidth={2} />}
                  variant="tertiary" className="show-hide-icon"
                  onClick={showHideIconClick} data-testid="column-icon-test"
                />
              )}
              {onExportAction && (
                <Button variant="secondary" onClick={onExportAction}
                  className="ml-auto" icon={<ImportIcon />}
                  data-testid="export-button-test-id"
                >
                  {t(LOCALE_CONST.downloadReport)}
                </Button>
              )}
            </div>
          }
        ></CardHeader>
        {renderTableContent()}
      </Card>
    </>
  );
};

export default CustomizedTable;